module.exports = __webpack_public_path__ + "img/fig11.7e4ce42f.jpg";